import React from 'react'
import Slider from "react-slick"

// Styles
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const ESlider = (props) => {

  const { settings, component } = props
  return (
    <Slider {...settings}>
      {component}

    </Slider>

  )
}

export default ESlider